import * as ROUTES from '../../routes/APP_URLS';
import { SET_NEXT_ROUTE_LOCATION } from '../constants';

const { PUBLIC_URLS } = ROUTES;

// get all private routes to pattern match against
const privateRoutes = () => {
  return Object.keys(ROUTES).reduce(
    // filter out all public routes and routes that end with tab
    (acc, curr) =>
      PUBLIC_URLS.includes(ROUTES[curr]) || curr.endsWith('_TAB') > 1
        ? acc
        : [...acc, ROUTES[curr]],
    [],
  );
};

export const doSetNextRouteLocation =
  ({ pathname }) =>
  ({ dispatch, store, getState }) => {
    const state = getState();
    const routeMatcher = store.selectRouteMatcher(state);

    // path to compare with the trailing slash if present
    const pathnameWithoutTrailingSlash = pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;

    // match that route against our known app routes
    const { pattern } = routeMatcher(pathnameWithoutTrailingSlash);

    // array of private routes to compare against
    const privateRoutesArray = privateRoutes();

    // if route provided matches a private route then set that location for them to be redirected to
    if (privateRoutesArray.includes(pattern))
      dispatch({
        payload: pathnameWithoutTrailingSlash,
        type: SET_NEXT_ROUTE_LOCATION,
      });
  };
